import api from '../axios.config';
import { API_ENDPOINTS, createEndpoint } from './endpoints';

export const JobService = {
  listJobs: async () => {
    const response = await api.get(API_ENDPOINTS.JOB.LIST);
    return response;
  },
  getJobDetails: async (id) => {
    const endpoint = createEndpoint(API_ENDPOINTS.JOB.GET, { id });
    const response = await api.get(endpoint);
    return response;
  },
  getJobInstitutions: async (jobCode) => {
    const endpoint = createEndpoint(API_ENDPOINTS.JOB.GET_JOB_INSTITUTIONS, {
      jobCode,
    });
    const response = await api.get(endpoint);
    return response;
  },
  assignInstitutionToJob: async (jobCode, data) => {
    const endpoint = createEndpoint(API_ENDPOINTS.JOB.GET_JOB_INSTITUTIONS, {
      jobCode,
    });
    const response = await api.post(endpoint, data);
    return response;
  },
};
